import { RequestService } from '../request/request.service';
import { ITranscription } from '../transcription/transcription.contract';

import {
  IActivity,
  ICreateActivity,
  IVideoCheckPoint,
  IRemoveActivity,
  IRemoveTask,
  IValidateTask,
  IUpdateActivityAuditStatus,
  IActivityWithSectionInfo,
  IUpdateActivity
} from './activity.contract';

export class ActivityService extends RequestService {
  public constructor(apiUrl: string) {
    super(apiUrl);
  }

  public createActivity = async ({ sectionId, activity, courseId }: ICreateActivity) => {
    return this.poster<IActivity, ICreateActivity['activity']>(
      `/courses/${courseId}/section/${sectionId}/activity`,
      activity
    );
  };

  public getActivity = async (activityId: string) => {
    return this.fetcher<IActivity>(`/activities/${activityId}`);
  };

  public updateActivity = async (
    activity: IUpdateActivity['activity'],
    courseId: string,
    sectionId: string
  ) => {
    return this.putter<IActivity, IUpdateActivity['activity']>(
      `/courses/${courseId}/section/${sectionId}/activity/${activity._id}`,
      activity
    );
  };

  public updateActivityAuditStatus = async (activity: IUpdateActivityAuditStatus) => {
    const { activityId, auditStatus } = activity;
    return this.putter<IActivity, Pick<IUpdateActivityAuditStatus, 'auditStatus'>>(
      `/activities/${activityId}/audit-status`,
      {
        auditStatus
      }
    );
  };

  public removeActivity = async ({
    sectionId,
    activityId,
    removeSyncedActivities
  }: IRemoveActivity) => {
    return this.deleter(`/sections/${sectionId}/activity/${activityId}`, {
      params: {
        removeSyncedActivities
      }
    });
  };

  public removeTask = async ({ activityId, taskId }: IRemoveTask) => {
    return this.deleter(`/activities/${activityId}/task/${taskId}`);
  };

  public validateTask = async ({ activityId, status, taskId, validation }: IValidateTask) => {
    return this.poster(`/activities/${activityId}/task/${taskId}/validate`, {
      status,
      ...validation
    });
  };

  public generateVideoCheckPoints = async (
    transcription: ITranscription
  ): Promise<{ questions: IVideoCheckPoint[] }> => {
    return this.putter(`/activities/${transcription.activity}/generate-video-checkpoints`, {
      content: transcription.content
    });
  };

  public getQuizActivities = async (quizId: string) => {
    return this.fetcher<IActivityWithSectionInfo[]>(`/activities/by-quiz/${quizId}`);
  };

  public unsyncActivity = async (activityId: string) => {
    return this.putter(`/activities/${activityId}/unsync`);
  };
}
